import { useEffect } from 'react';
import { Navigate, Outlet, matchPath, useLocation } from 'react-router-dom';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import {
  NBA_MARKET_COMMON_MARKET_ADD_CARD,
  NBA_PLAY_COMMON_MARKET,
} from '@sorare/core/src/constants/__generated__/routes';

import { CommonMarketHeader } from '@sorare/marketplace/src/components/commonCard/CommonMarketHeader';

import { useNBAEvents } from '@sorare/gameplay/src/lib/events';

const NBACommonMarketLayout = () => {
  const track = useNBAEvents();
  const location = useLocation();

  useEffect(() => {
    track('View Common Market');
  }, [track]);

  if (matchPath(location.pathname, NBA_PLAY_COMMON_MARKET)) {
    return <Navigate to={NBA_MARKET_COMMON_MARKET_ADD_CARD} replace />;
  }
  return (
    <ContentWithStickyHeader header={<CommonMarketHeader />}>
      <Outlet />
    </ContentWithStickyHeader>
  );
};

export default NBACommonMarketLayout;
